import ErrorScreenTopArea from '../common/ErrorScreenTopArea'
import NavBar from '../common/NavBar'

export default function NotFound() {
  return (
    <>
      <NavBar />
      <div className="h-screen flex flex-col justify-between">
        <ErrorScreenTopArea
          title="找不到頁面"
          content={
            <p className="babu-text-paragraph text-text600">
              可能是連結有問題，請再嘗試一次
            </p>
          }
        />
      </div>
    </>
  )
}
